import {
    FormControl,
    Input,
    InputAdornment, InputLabel,
    makeStyles,
    Typography
} from "@material-ui/core";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { validAscents } from "../../../constants/propTypesValidation";
import { styledBy } from "../../../utils/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: theme.spacing(1),
    },
    input: {
        color: theme.palette.ascents.white,
        "&:before": {
            borderBottom: `1px solid ${theme.palette.ascents.primary} !important`,
        },
        "&:after": {
            borderBottomColor: styledBy("ascent", theme.palette.ascents),
            borderBottom: "none",
            background: `linear-gradient(45deg, ${theme.palette.ascents.primary} 20%, ${theme.palette.ascents.primary}) 80%`,
            height: "1px",
        },
        "&.MuiInputLabel-asterisk": {
            color: theme.palette.ascents.orange,
        },
        "&:hover": {
            "&:before": {
                borderBottom: `1px solid ${theme.palette.ascents.primary} !important`,
            },
        }
    },
    label: {
        color: styledBy("ascent", theme.palette.ascents),
        fontSize: '1rem',
        "&.MuiInputLabel-shrink": {
            color: theme.palette.ascents.primary,
        },
        "&.MuiInputLabel-asterisk": {
            color: theme.palette.ascents.orange,
        },
    },
    labelForDate: {
        fontSize: 10,
    },
}));

const TextBox = ({
    id,
    ascent = "primary",
    disabled,
    endAdornment,
    startAdornment,
    value,
    type = "text",
    label = "Enter Something",
    showLabel = true,
    multiline = false,
    onChange = () => { },
    inputClassName,
    parentClassName,
    labelClassName,
    inputProps,
    labelProps,
    labelForDate,
    readOnly = false,
    required = false,
    ...props
}) => {
    const classes = useStyles({ ascent });

    return (
        <FormControl
            fullWidth
            required={required}
            {...props}
            className={clsx(classes.root, parentClassName)}
        >
            {showLabel ? (
                <InputLabel
                    className={clsx(classes.label, labelClassName)}
                    htmlFor={id}
                    shrink={type === 'date' ? true : undefined}
                    {...labelProps}
                >
                    {label.concat(required ? "*" : "")}
                </InputLabel>
            ) : labelForDate ? (
                <Typography
                    className={clsx(classes.label, classes.labelForDate, labelClassName)}
                >
                    {labelForDate.concat(required ? "*" : "")}
                </Typography>
            ) : null}
            <Input
                id={id}
                type={type}
                value={value}
                onChange={onChange}
                multiline={multiline}
                ascent={ascent}
                className={clsx(classes.input, inputClassName)}
                // placeholder={!showLabel ? label.concat(required ? "*" : "") : null}
                endAdornment={
                    endAdornment ? (
                        <InputAdornment position='end'>
                            {endAdornment}
                        </InputAdornment>
                    ) : null
                }
                startAdornment={
                    startAdornment ? (
                        <InputAdornment position='start'>
                            {startAdornment}
                        </InputAdornment>
                    ) : null
                }
                required={required}
                readOnly={readOnly}
                {...inputProps}
            />
        </FormControl>
    );
};

TextBox.propTypes = {
    ascent: validAscents,
    endAdornment: PropTypes.node,
    startAdornment: PropTypes.node,
    inputProps: PropTypes.object,
    labelProps: PropTypes.object,
    onChange: PropTypes.func,
    showLabel: PropTypes.bool,
};

export default TextBox;
